<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Quiz Scheduling
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="sub-row" justify="center" dense>
                <!-- <v-col cols="12" xs="12" sm="2" lg="4" md="12"> -->
                <!-- </v-col> -->
                <!-- <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                     <p class="padding-bot"><b>Academic Year</b></p>
                 <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd();" />
            </v-col> -->
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Subject</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="course"
                        return-object
                        :items="course_offering_instructor_details"
                        item-text="course"
                        item-value="course_id"
                        label="Subject"
                        outlined
                        @change="getDivisions(course);"
                    />
                </v-col>
                <!-- <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                     <p class="padding-bot"><b>Standard</b></p>
                 <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object :items="ay_std_div_list" item-text="ay" label="Standard" outlined @change="getStd();" />
            </v-col> -->
            </v-row>
        </v-card>
        <v-card class="box" v-if="course">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Quiz Scheduling
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            
            <v-row class="sub-row">
                <v-col cols="12" xs="12" sm="2" lg="3" md="12"> </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Title</b></p>
                    <v-text-field class="padding-bot" outlined dense v-model="title" aria-required="true"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Description</b></p>
                    <v-text-field class="padding-bot" outlined dense v-model="description"></v-text-field>
                </v-col>
            </v-row>
            <v-row class="sub-row">
                <v-col cols="12" xs="12" sm="2" lg="3" md="12"> </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Do You Want To Schedule On Particular Date?</b></p>
                    <!-- <span style="color:black">(To enable video conferencing every learner should have at least 2 Mbps internet connection)</span> -->
                    <!-- <input type="chechbox" id="checkbox" v-model="checked"  @click="displayfn1(this)"/> -->
                    <v-checkbox class="padding-bot" v-model="onparticulardate" dense></v-checkbox>
                </v-col>
            </v-row>
            <v-row class="sub-row">
                <v-col cols="12" xs="12" sm="2" lg="3" md="12"> </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Start Date</b></p>
             <v-datetime-picker dateFormat="dd-MM-yyyy" label="Select Start Datetime" v-model="startdate"></v-datetime-picker>

                    <!-- <input type="date" class="padding-bot" id="datePickerId" v-model="startdate" @change="changeenddate(this)" /> -->
                </v-col>
                <!-- <v-col cols="12" xs="12" sm="1" lg="1" md="12">
            </v-col> -->
                <v-col cols="12" xs="12" sm="3" lg="3" md="12" v-if="onparticulardate == false">
                    <!-- <p class="padding-bot"><b>Start Time</b></p> -->
                      <p class="padding-bot"><b>End Date</b></p>
                    <!-- <input type="time" class="padding-bot" v-model="starttime" /> -->
                     <v-datetime-picker dateFormat="dd-MM-yyyy" label="Select End Datetime" v-model="changeenddate1" persistent></v-datetime-picker>
                </v-col>
            </v-row>
            <!-- <v-row v-if="onparticulardate == false">
                <v-col cols="12" xs="12" sm="2" lg="3" md="12"> </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>End Date</b></p>
                    <input type="date" class="padding-bot" outlined dense v-model="changeenddate1" readonly />
                    <datetime outlined dense format="DD-MM-YYYY"  v-model="enddate" ></datetime> 
                </v-col> -->
                <!-- <v-col cols="12" sm="1">
            </v-col> -->
                <!-- <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>End Time</b></p>
                    <input type="time" class="padding-bot" v-model="endtime" />
                </v-col> 
            </v-row>-->
            <v-row>
                <v-col cols="12" xs="12" sm="2" lg="3" md="12"> </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Divisions</b></p>
                    <v-select multiple :items="dividionlist" class="padding-bot" item-text="division" item-value="div_off_id" outlined dense v-model="division"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Is Meeting Link Applicable.?</b></p>
                    <!-- <span style="color:black">(To enable video conferencing every learner should have at least 2 Mbps internet connection)</span> -->
                    <!-- <input type="chechbox" id="checkbox" v-model="checked"  @click="displayfn1(this)"/> -->
                    <v-checkbox class="padding-bot" v-model="ismeetinglinkapplicable" dense></v-checkbox>
                </v-col>
            </v-row>
            <div v-if="ismeetinglinkapplicable == true">
                <v-card class="main box" flat>
                    <v-row>
                        <v-col lg="1" md="12"></v-col>
                        <v-col cols="12" xs="12" sm="12" lg="3" md="12">
                            <br />
                            <v-btn class="padding-bot button" id="schdl_wbnr" data-animated @click="openWindow(750,500)">Schedule / Host Zoom Meeting</v-btn>
                            <span class="ml-2" style="color: blue;">(Ex::<b>https://us04web.zoom.us/wc/75290204898)</b></span>
                        </v-col>
                        <v-col lg="1"></v-col>
                        <v-col cols="12" xs="12" sm="12" lg="3" md="12">
                            <br />
                            <v-btn class="padding-bot button" id="schdl_wbnr" data-animated @click="openWindowMeet(750,500)">Schedule / Host Google Meet</v-btn>
                            <span class="ml-4" style="color: blue;">(Ex::<b>https://meet.google.com)</b></span>
                        </v-col>
                        <v-col cols="12" xs="12" lg="1" md="12"></v-col>
                        <v-col class="padding-metting" cols="12" xs="12" sm="12" lg="3" md="12">
                            <center><label>Meeting Link</label></center>
                            <v-text-field class="padding-bot" outlined dense v-model="meetingLink" @change="validateWebinarURL(meetingLink)"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
            <br />
            <v-container>
                <v-row justify="center" dense v-if="this.chapters.length > 0">
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete dense multiple rounded outlined :items="chapters" item-text="name" item-value="id" v-model="selected_chapter" label="Select Chapter"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete dense multiple rounded outlined :items="quiztype" item-text="name" item-value="id" v-model="selected_quiztype" label="Select Quiz Type"></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row class="justify-center" >
                    <v-btn class="button" :loading="loader" @click="getquestiontable">Select Questions</v-btn>
                </v-row>
                <br />
                <br />
                <template v-if="this.showtable == true">
                    <v-data-table v-model="selected" :headers="question_table_headers" :items="questions" item-key="qid" show-select class="elevation-1 " items-per-page="-1">
                        <template v-slot:[`item.question`]="{ item }">
                            <span v-html="item.question">
                                {{ item.question }}
                            </span>
                        </template>
                        <template v-slot:[`item.question_file`]="{ item }">
                            <span v-if="item.file_link!=null">
                                <a class="p-2" :href="basepath+item.file_link" target="blank">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-if="item.file_link!=null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span>
                                            View Question File!!!
                                        </span>
                                    </v-tooltip>
                                </a>
                            </span>
                            <span v-else>--</span>
                        </template>
                    </v-data-table>
                </template>
               

                <!-- <v-simple-table v-model="showtable" v-if="showtable == true" class="elevation-1">
                    <template>
                        <thead v-if="questions!=null">
                            <tr>
                                <th>Sr.No.</th>
                                <th>Quiz Type</th>
                                <th>Quiz Statement</th>
                                <th>Quiz File</th>
                                <th>Chapter</th>
                                <th>Marks</th>
                                <th>
                                    Select / unselect All
                                    <span> <input color="#0F2027" type="checkbox" id="myCheckfam" name="myCheckfam" @click="checkUnCheckfamily(questions)" /></span>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item,i) in questions" :key="item">
                                <td>{{i+1}}</td>
                                <td>{{item.quiztype}}</td>
                                <td>
                                    <span style="opacity: 1;" v-html="item.question"></span>
                                    <span v-if="item.file_link!=null">
                                <img class="imgs" :src="basepath+item.file_link" v-if="item.file_link!=null" @click="zooimg(basepath+item.file_link)" />
                            </span> 
                                </td>
                                <td>
                                    <span v-if="item.file_link!=null">
                                        <a class="p-2" :href="basepath+item.file_link" target="blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-if="item.file_link!=null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                </template>
                                                <span>
                                                    View Question File!!!
                                                </span>
                                            </v-tooltip>
                                        </a>
                                    </span>
                                    <span v-else>--</span>
                                </td>
                                <td>{{item.weightage}}</td>
                                <td>{{item.chapter}}</td>
                                <td>
                                    <span> <input type="checkbox" color="#0F2027" class="family" id="questionid" name="questionid" v-model="questionid" :value="item" />
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </template>

                    <br />
                </v-simple-table> -->
                <br />
                <v-row justify="center" v-if="showtable == true">
                    <v-btn class="button" :loading="loader" @click="gettotal_marks">Save</v-btn>
                </v-row>
            </v-container>
        </v-card>
        <v-card class="box">
            <v-data-table :headers="headers" :items="offeredQuizList" sort-by="srno" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Quiz Scheduling List
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.meeting_link`]="{ item }">
                    <span v-if="item.meeting_link">
                        <a :href="item.meeting_link" target="_blank">
                        <v-icon size="40">mdi mdi-link</v-icon></a>
                    </span>
                    <span v-else>
                        <label>--</label>
                    </span>
                </template>
                <template v-slot:[`item.questions`]="{ item }">
                    <v-icon class="mr-2 v-icon-size" @click="viewQuestions(item.id)" color="#0F2027">mdi-eye</v-icon>
                </template>
                <template v-slot:[`item.isactive`]="{ item }">
                    <v-switch v-model="item.isactive" color="#0F2027" @change="toggle(item)"></v-switch>
                </template>
                <template v-slot:[`item.edit`]="{ item }">
                    <v-icon class="mr-2 v-icon-size" @click="editscheduling(item)" color="success">mdi-pencil</v-icon>
                </template>
                <template v-slot:[`item.result`]="{ item }">
                    <v-icon  class="mr-2 v-icon-size" @click="checkandcalculate(item)" color="success">mdi-book-open</v-icon>
                </template>
                <template v-slot:[`item.declare`]="{ item }">
                    <v-icon  class="mr-2 v-icon-size" @click="declare(item)" color="success">mdi-marker-check</v-icon>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog_vewiquestions" persistent max-width="1200px">
            <v-card>
                <!-- <v-card-title>
                    <span class="headline">View Questions</span>
                </v-card-title>
                <br> -->
                <v-toolbar dense flat class="toolbar">
                    <v-toolbar-title>
                        <strong>
                            View Question
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table class="elevation-1">
                        <template>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Quiz Type</th>
                                    <th>Quiz Statement</th>
                                    <th>Quiz File</th>
                                    <th>Marks</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item,i) in viewquizquestions" :key="item">
                                    <td>{{i+1}}</td>
                                    <td>{{item.quiztype}}</td>
                                    <td>
                                        <span style="opacity: 1;" v-html="item.question"></span>
                                        <!-- <span v-if="item.file_link!=null">
                                            <img class="imgs" :src="basepath+item.file_link" v-if="item.file_link!=null" @click="zooimg(basepath+item.file_link)" />
                                        </span> -->
                                    </td>
                                    <td>
                                        <span v-if="item.file_link!=null">
                                            <a class="p-2" :href="basepath+item.file_link" target="blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-if="item.file_link!=null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                    </template>
                                                    <span>
                                                        View Question File!!!
                                                    </span>
                                                </v-tooltip>
                                            </a>
                                        </span>
                                        <span v-else>--</span>
                                    </td>
                                    <td>{{item.weightage}}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-row justify="center" dense>
                    <v-btn class="button" @click="dialog_vewiquestions = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_confirmation" persistent max-width="500px">
            <v-card>
                <v-container>
                    <v-card class="box">
                        <strong>Total Weightage = {{total_marks}}. Are you sure you want to schedule the Quiz?</strong>
                        <v-row dense justify="center">
                            <v-btn class="button" @click="dialog_confirmation = false;total_marks = 0">No</v-btn>
                            <v-btn class="button" @click="save()">Yes</v-btn>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
        </v-dialog>
         <v-dialog v-model="dialog_editschedule" persistent max-width="1300px">
            <v-card class="box">
                <v-card-title class="justify-center">
                    Test Edit
                </v-card-title>
                <v-card-text>
                    <v-row class="sub-row">
                        <v-col cols="12" xs="12" sm="2" lg="3" md="12">
                        </v-col>
                       <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                            <p class="tx-bold">Tite</p>
                            <v-text-field outlined dense v-model="editedItem.title" aria-required="true"></v-text-field>
                        </v-col>
                      <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                            <p class="tx-bold">Description</p>
                            <v-text-field outlined dense v-model="editedItem.description"></v-text-field>
                        </v-col>
                    </v-row>
                   <v-row class="sub-row">
                <v-col cols="12" xs="12" sm="2" lg="3" md="12"> </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Do You Want To Schedule On Particular Date?</b></p>
                    <v-checkbox class="padding-bot" v-model="editedItem.is_scheduled_in_slot" dense></v-checkbox>
                </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                            <p class="tx-bold">Is Meeting Link Applicable ?</p>
                            <v-checkbox v-model="editedItem.is_meeting_link_applicable" dense></v-checkbox>
                        </v-col>
            </v-row>
            <v-row class="sub-row">
                <v-col cols="12" xs="12" sm="2" lg="3" md="12"> </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><v-icon color="error">*</v-icon><b>Start Date</b></p>
             <v-datetime-picker dateFormat="dd-MM-yyyy" label="Select Start Datetime" v-model="editedItem.start_date"></v-datetime-picker>
                </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12" v-if="editedItem.is_scheduled_in_slot == false">
                      <p class="padding-bot"><v-icon color="error">*</v-icon><b>End Date</b></p>
                      
                     <v-datetime-picker dateFormat="dd-MM-yyyy" label="Select End Datetime" v-model="editedItem.end_date" persistent></v-datetime-picker>
                </v-col>
            </v-row>
                    <div v-if="editedItem.is_meeting_link_applicable == true">
                        <v-card class="main box" flat>
                    <v-row>
                        <v-col lg="1" md="12"></v-col>
                        <v-col cols="12" xs="12" sm="12" lg="3" md="12">
                            <br />
                            <v-btn class="padding-bot button" id="schdl_wbnr" data-animated @click="openWindow(750,500)">Schedule / Host Zoom Meeting</v-btn>
                            <span class="ml-2" style="color: blue;">(Ex::<b>https://us04web.zoom.us/wc/75290204898)</b></span>
                        </v-col>
                        <v-col lg="1"></v-col>
                        <v-col cols="12" xs="12" sm="12" lg="3" md="12">
                            <br />
                            <v-btn class="padding-bot button" id="schdl_wbnr" data-animated @click="openWindowMeet(750,500)">Schedule / Host Google Meet</v-btn>
                            <span class="ml-4" style="color: blue;">(Ex::<b>https://meet.google.com)</b></span>
                        </v-col>
                        <v-col cols="12" xs="12" lg="1" md="12"></v-col>
                        <v-col class="padding-metting" cols="12" xs="12" sm="12" lg="3" md="12">
                            <center><label>Meeting Link</label></center>
                            <v-text-field class="padding-bot" outlined dense v-model="editedItem.meeting_link" @change="validateWebinarURL(editedItem.meeting_link)"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
                    </div>
                </v-card-text>
                <br>
                <v-row justify="center">
                    <v-btn color="primary"  :loading="loader" @click="saveeditscheduling(editedItem.quizOfferingId)">Update</v-btn>
                </v-row>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="primary" @click="dialog_editschedule = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row justify="center">
            <v-dialog v-model="dialog_showstudentdata" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar class="toolbar">
                        <v-btn icon dark @click="dialog_showstudentdata = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>All Results</v-toolbar-title>
                        <v-toolbar-items>
                            <v-btn dark text @click="dialog_showstudentdata = false">Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                     <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Quiz Results
                        </strong>
                    </v-toolbar-title>
            </v-toolbar>
                     <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                        <v-data-table :headers="headers_result" :items="showstudentdata" :search="search" class="elevation-1 ">
                    <template v-slot:[`item.check`]="{ item }">
                             <span v-if="item.isautoevaluted == false">
                            <v-btn class="button" :loading="loader" @click="check(item)">Check</v-btn></span>
                            <span v-else>--</span>
                    </template>
                        </v-data-table>
                </v-col>
                      </v-row>
                     </v-card>
                </v-card>
            </v-dialog>
     </v-row>
       <v-row justify="center">
            <v-dialog v-model="dialog_check" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar class="toolbar">
                        <v-btn icon dark @click="dialog_check = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>All Results</v-toolbar-title>
                        <v-toolbar-items>
                            <v-btn dark text @click="dialog_check = false">Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                     <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Quiz Checking
                        </strong>
                    </v-toolbar-title>
            </v-toolbar>
                     <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                        <v-data-table :headers="headers_check" :items="quizResultDetails" :search="search_quizResultDetails" class="elevation-1 ">
                    <template v-slot:[`item.question`]="{ item }">
                            <span v-html="item.question">
                                {{ item.question }}
                            </span>
                        </template>
                        <template v-slot:[`item.question_file`]="{ item }">
                            <span v-if="item.question_file!=null">
                                <a class="p-2" :href="basepath+item.question_file" target="blank">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-if="item.question_file!=null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span>
                                            View Question File!!!
                                        </span>
                                    </v-tooltip>
                                </a>
                            </span>
                            <span v-else>--</span>
                        </template>
                        <template v-slot:[`item.answer`]="{ item }">
                            <span v-html="item.answer">
                                {{ item.answer }}
                            </span>
                        </template>
                        <template v-slot:[`item.file_link`]="{ item }">
                            <span v-if="item.file_link!=null">
                                <a class="p-2" :href="basepath+item.file_link" target="blank">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-if="item.file_link!=null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span>
                                            View Answer File!!!
                                        </span>
                                    </v-tooltip>
                                </a>
                            </span>
                            <span v-else>--</span>
                        </template>
                    <template v-slot:[`item.give_marks`]="{ item }">
                            <v-row class="sub-row" dense><br>
                        <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                            <v-text-field  class="padding-bot" outlined dense type="number" v-model="item.marks" ></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                            <v-btn  class="button" :loading="loader" @click="Save_Marks(item.id,item.marks)">Save</v-btn>
                        </v-col>
                </v-row>
                    </template>
                     <template v-slot:[`item.marks_given`]="{ item }">
                            <span v-if="item.marks_given">
                                {{ item.marks_given }}
                            </span>
                            <span v-else>--</span>
                        </template>
                        </v-data-table>
                </v-col>
                      </v-row>
                     </v-card>
                </v-card>
            </v-dialog>
     </v-row>
      <v-row justify="center">
            <v-dialog v-model="declare_result_dialog" persistent max-width="500px">
                <v-card>
                    <v-toolbar class="toolbar">
                        <v-toolbar-title>Declare Results</v-toolbar-title>
                      </v-toolbar>
                      <v-container>
                    <v-card class="box">
                        <strong>Total Students = {{this.students}}</strong><br>
                        <strong>Total Number Of Subjective Questions = {{this.total_count}}</strong><br>
                        <strong>Total Number Of Subjective Questions Evaluated = {{this.evaluated_count}}</strong><br>
                        <strong>Are You Sure You Want To Declare The Result..?</strong><br>

                        <v-row dense justify="center">
                            <v-btn class="button" @click="declare_result_dialog = false">No</v-btn>
                            <v-btn class="button" @click="declare_result()">Yes</v-btn>
                        </v-row>
                    </v-card>
                 </v-container>
                   
                </v-card>
            </v-dialog>
      </v-row>

    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datetime from "vuejs-datetimepicker";
import moment from "moment";
    export default {
          components: {
            Datepicker,
            datetime,
        },
        data: () => ({

            
            students:"",
            total_count:"",
            evaluated_count:"",
            result_id:"",
            schedule_id:"",
            declare_result_dialog:false,
            search_quizResultDetails:"",
            marks:"",
            quizResultDetails:[],
            headers_check:[
            { text: "Sr. No.", value: "srno", sortable: "true" },
            { text: "Quiz Title", value: "title" },
            { text: "Question", value: "question", sortable: "true" },
            { text: "Question-File", value: "question_file", sortable: "true" },
            { text: "Answer", value: "answer", sortable: "true" },
            { text: "Answer File", value: "file_link", sortable: "true" },
            { text: "Submission Date", value: "submission_date", sortable: "true" },
            { text: "Question Marks", value: "question_marks", sortable: "true" },
            { text: "Marks Given", value: "marks_given", sortable: "true" },
            { text: "Marks", value: "give_marks", sortable: "true", width:300 },
            ],
            headers_result:[
            { text: "Sr. No.", value: "srno", sortable: "true" },
            { text: "Title", value: "title" },
            { text: "Learner", value: "learner", sortable: "true" },
            { text: "Marks", value: "marks", sortable: "true" },
            { text: "Check Subjective", value: "check", sortable: "true" },
            ],
            showstudentdata:[],
            dialog_showstudentdata:false, 
            dialog_check:false, 
            editedItem: {
                id: "",
                title: "",
                description: "",
                start_date: "",
                end_date: "",
                is_meeting_link_applicable: "",
                is_scheduled_in_slot:"",
        },
            dialog_editschedule:false,
            singleSelect: false,
            selected: [],
            question_table_headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Chapter", value: "chapter" },
                { text: "Quiz Type", value: "quiztype" },
                { text: "Question", value: "question" },
                { text: "Question File", value: "question_file" },
                { text: "Weightage", value: "weightage" },
            ],
            headers: [
                { text: "Sr. No.", value: "srno", sortable: "true" },
                { text: "Title", value: "title" },
                { text: "Course", value: "course", sortable: "true" },
                { text: "Division", value: "division", sortable: "true" },
                { text: "Standard", value: "standard", sortable: "true" },
                { text: "Start Date", value: "start_date" },
                { text: "End Date", value: "end_date", sortable: "true" },
                { text: "Meeting link", value: "meeting_link", sortable: "false" },
                { text: "Questions", value: "questions", sortable: "false" },
                { text: "Is-Active", value: "isactive", sortable: "false" },
                { text: "Edit", value: "edit", sortable: "false" },
                { text: "Check", value: "result", sortable: "false" },
                { text: "Declare Result", value: "declare", sortable: "false" },
            ],
            dialog_vewiquestions: false,
            changeenddate1: "",
            course: "",
            title: "",
            loader: false,
            search: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            title: null,
            starttime: null,
            endtime: null,
            category: null,
            description: null,
            startdate: null,
            enddate: null,
            offeredQuizList: [],
            dividionlist: [],
            division: "",
            ismeetinglinkapplicable: false,
            onparticulardate: false,
            course_offering_instructor_details: [],
            course: "",
            questions: [],
            showtable: false,
            savemeetlink: false,
            questionid: [],
            meetingLink: "",
            offeredQuizList: [],
            basepath: null,
            viewquizquestions: null,
            chapters: [],
            selected_chapter: [],
            quiztype: [],
            selected_quiztype: [],
            total_marks: 0,
            weightage_marks: [],
            dialog_confirmation: false,
        }),
        methods: {
            declare_result(){
                 const data = {
                    quiz_schedule_id:this.schedule_id,
                 };
            axios
                .post("/QuizScheduling/declareResult", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.declare_result_dialog=false
                         this.showSnackbar("#4caf50","Result Declared Successfully...");
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {});
            },
            declare(item){
                //this.result_id=item.quiz_schedule_id
               // this.declare_result_dialog=true
                //return
               // alert(item.id)
                  const data = {
                    quiz_schedule_id:item.id,
                 };
            axios
                .post("/QuizScheduling/getAllResultData", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.students=res.data.students
                        this.total_count=res.data.total_count
                        this.evaluated_count=res.data.evaluated_count
                        this.schedule_id=res.data.schedule_id
                        this.declare_result_dialog=true
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {});
            },
            Save_Marks(id,marks){
               // alert("id::"+id)
                //alert("marks::"+marks)
                //return
                

                
                const data = {
                       quiz_submission_id:id,
                       marks:marks
                    };
                 
            axios
                .post("/QuizScheduling/saveMarks", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.quizResultDetails=res.data.quizResultDetails
                        this.showSnackbar("#4caf50", res.data.snackbar);
                        return
                    }else if(res.data.flag == "No"){
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        return
                    } 
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {});
            },
            check(item){
                 const data = {
                       quiz_schedule_id:item.quiz_schedule_id,
                       learner_id:item.learner_id
                 };
            axios
                .post("/QuizScheduling/check", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.quizResultDetails=res.data.quizResultDetails
                        this.dialog_check=true
                        //this.showSnackbar("#4caf50", "Updated successfully");
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {});
            },
            checkandcalculate(item){
                const data = {
                       item:item.id
                 };
            axios
                .post("/QuizScheduling/checkandcalculate", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.showstudentdata=res.data.learnerQuizResult
                        this.dialog_showstudentdata=true
                        //this.showSnackbar("#4caf50", "Updated successfully");
                    }else if(res.data.flag == "No") {
                         this.showSnackbar("#b71c1c", res.data.snackbar);
                         return
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {});
            },
            saveeditscheduling(){

                 


                var start_date = moment(this.editedItem.start_date).format("YYYY-MM-DD HH:mm")
                    if(this.editedItem.is_scheduled_in_slot == false){
                    var end_date = moment(this.editedItem.end_date).format("YYYY-MM-DD HH:mm")
                }
                this.editedItem.start_date=start_date;
                if(this.editedItem.is_scheduled_in_slot == false){
                  this.editedItem.end_date=end_date;
                }
                         if (this.end_date == null) {
                            this.showSnackbar("#b71c1c", "Please select End Date and Time!!!"); // show snackbar
                            this.loader = false;
                        }
                    const data = {
                    item:this.editedItem
                };
                axios
                    .post("/QuizScheduling/saveeditscheduling", data)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Updated successfully");
                            this.dialog_editschedule=false
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                           
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            editscheduling(quiz){
                 const data = {
                    quiz_id: quiz.id,
                };
                axios
                    .post("/QuizScheduling/editQuizoffering", data)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            //this.showSnackbar("#4caf50", "Updated successfully");
                            this.editedItem = res.data.quizDetails[0];
                            var momentDate = moment(res.data.quizDetails[0].start_date);
                            var end_date = moment(res.data.quizDetails[0].end_date);
                            this.editedItem.start_date = momentDate.toDate();
                            this.editedItem.end_date = end_date.toDate();
                            this.dialog_editschedule=true
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                           
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            toggle(tg) {
                //alert("toggle")
                const toggle = {
                    quiz_id: tg.id,
                    quiz_status: tg.isactive,
                };
                axios
                    .post("/QuizScheduling/toggleQuizoffering", toggle)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Updated successfully");
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            this.onLoad();
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            viewQuestions(quizid) {
                // alert("in viewQuestions....."+quizid)
                const data = {
                    quizid: quizid,
                };
                axios
                    .post("/QuizScheduling/viewquestions", data)
                    .then((res) => {
                        // console.log(res.data)
                        if (res.data.flag == "Yes") {
                            this.viewquizquestions = res.data.questions;
                            this.dialog_vewiquestions = true;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            validateWebinarURL(link) {
                ///alert("validateWebinarURL::"+link)
                var myURL = link;
                var mytrimurl = myURL.trim();
                //alert('url'+myURL)
                var pattern = new RegExp(
                    "^((ft|htt)ps?:\\/\\/)?" + // protocol
                    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
                    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                    "(\\:\\d+)?" + // port
                    "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
                    "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
                        "(\\#[-a-z\\d_]*)?$",
                    "i"
                ); // fragment locator');
                if (pattern.test(mytrimurl)) {
                    this.editeetlink = true;
                    this.savemeetlink = true;
                    this.copymeetlink = true;
                    return true;
                } else {
                    this.editeetlink = false;
                    this.savemeetlink = false;
                    this.copymeetlink = false;
                    this.showsnackbar("Please Enter Valid URL...!", "error", 3000);
                    return false;
                }
            },
            gettotal_marks() {
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_marks = this.total_marks + this.selected[i].weightage;
                    this.questionid.push(this.selected[i].qid);
                }
                this.dialog_confirmation = true;
            },
            save() {
                //  for (var i = 0; i < this.selected.length; i++) {
                //     //alert("wt---"+this.selected[i].weightage)
                //     this.total_marks = this.total_marks + this.selected[i].weightage
                //     this.questionid.push(this.selected[i].qid);
                // }

                //    alert("total_marks::"+this.total_marks)
                //    return

                if (this.questionid == "" || this.questionid == null) {
                    // alert("in ifff.....")
                    this.showSnackbar("#b71c1c", "Please Select Questions...");
                    return;
                }
                if (this.ismeetinglinkapplicable == true) {
                    if (this.savemeetlink == false) {
                        this.showSnackbar("#b71c1c", "Please Enter Valid Meeting URL......!");
                        return;
                    }
                }
                this.dialog_confirmation = false;
                this.loader = true;
                var start_date = moment(this.startdate).format("YYYY-MM-DD HH:mm")
                if(this.onparticulardate == false){
                var end_date = moment(this.changeenddate1).format("YYYY-MM-DD HH:mm")
                }
                const data = {
                    title: this.title,
                    description: this.description,
                    start_date: start_date,
                    end_date: end_date,
                    starttime: this.starttime,
                    endtime: this.endtime,
                    meetingLink: this.meetingLink,
                    ismeetinglinkapplicable: this.ismeetinglinkapplicable,
                    questionid: this.questionid,
                    courseId: this.course,
                    divisions: this.division,
                    total_marks: this.total_marks,
                    onparticulardate:this.onparticulardate,
                };
                axios
                    .post("/QuizScheduling/savequizschedule", data)
                    .then((res) => {
                        // console.log(res.data)
                        if (res.data.flag == "Yes") {
                            this.showtable = false;
                            (this.title = ""),
                                (this.description = ""),
                                (this.startdate = null),
                                (this.changeenddate1 = null),
                                (this.starttime = null),
                                (this.endtime = null),
                                (this.meetingLink = ""),
                                (this.isshuffleapplicable = false),
                                (this.ismeetinglinkapplicable = false),
                                (this.questionid = ""),
                                //this.c_id='',
                                (this.division = "");
                                (this.questions=[]);
                                (this.dividionlist=[]);
                                (this.chapters= []);
                                (this.selected_chapter= []);
                                (this.quiztype= []);
                                (this.selected_quiztype= []);
                                (this.onparticulardate=false)
                              //  (this.showtable=false)
                            this.loader = false;
                            this.showSnackbar("#4caf50","Quiz Scheduled Successfully...");
                            this.onLoad();
                        } else if (res.data.status == "NO") {
                            this.loader = false;
                           // this.showsnackbar("Same Quiz Already Present...", "error", 5000);
                           this.showSnackbar("#b71c1c",res.data.snackbar);
                        } else {
                            this.loader = false;
                           this.showSnackbar("#b71c1c", "Something went wrong !!!");
                        }
                    })
                    .catch((error) => {})
                    .finally(() => {
                        this.overlay = false;
                    });
            },

            checkUnCheckfamily(chk) {
                alert("checkUnCheckfamily");
                var flag = false;
                var checkBox = document.getElementById("myCheckfam");
                var family = document.getElementsByClassName(chk);
                this.questionid = [];
                if (checkBox.checked == true) {
                    for (var i = 0; i < chk.length; i++) {
                        //chk[i].checked = true;
                        // this.questionid.push(chk[i].qid);
                        this.questionid.push(chk[i].qid);
                        this.weightage_marks.push(chk[i].weightage);
                        this.total_marks += chk[i].weightage;
                    }
                } else {
                    //alert("elseee")
                    this.questionid = [];
                    var family = document.getElementsByClassName("family");
                    for (var i = 0; i < family.length; i++) {
                        //alert("i")
                        family[i].checked = false;
                        this.total_marks = 0;
                    }
                }
                //alert(" this.checkboxes:"+ this.checkboxes)
            },
            changeenddate(date) {
                //alert("date::"+this.startdate)
                const data = {
                    date: this.startdate,
                };
                //alert("data::"+data.date)
                axios
                    .post("/QuizScheduling/changeenddate", data)
                    .then((res) => {
                        // console.log(res.data)
                        if (res.data.flag == "Yes") {
                            this.changeenddate1 = res.data.enddate;
                        } else {
                           this.showSnackbar("#b71c1c", "Something went wrong !!!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});

                // this.close();
            },
            getquestiontable() {
                // alert("div---"+this.division.length)
                // return
                if (this.course == null || this.course == "") {
                    this.showSnackbar("#b71c1c", "Please Select Course!");
                    return;
                }
                if (this.title == null || this.title == "") {
                    this.showSnackbar("#b71c1c", "Please Enter Title!");
                    return;
                } else if (this.title.trim() == null || this.title.trim() == "") {
                    this.showSnackbar("#b71c1c", "Please Enter Title!");
                    return;
                } else if (this.startdate == null || this.startdate == "") {
                    this.showSnackbar("#b71c1c", "Please Select Start Date!");
                    return;
                }  else if(this.division.length == 0){
                    this.showSnackbar("#b71c1c", "Please Select Division..!");
                    return;
                }else if (this.selected_chapter.length == 0){
                    this.showSnackbar("#b71c1c", "Please Select Chapter..!");
                    return
                }else if (this.selected_quiztype.length == 0){
                    this.showSnackbar("#b71c1c", "Please Select Quiz Type..!");
                    return
                }
                else if(this.onparticulardate == false){ 
                    if (this.changeenddate1 == null || this.changeenddate1 == "") {
                        this.showSnackbar("#b71c1c", "Please Select End Date!");
                        return;
                    } 
                }
                // else if (this.endtime == null || this.starttime == null) {
                //     this.showSnackbar("#b71c1c", "Please Enter Start Time And End Time!");
                //     return;
                // } else if (this.endtime <= this.starttime) {
                //     this.showSnackbar("#b71c1c", "Please Enter End Time Greater Than Start Time!");
                //     return;
                //}
               
                 else if (this.ismeetinglinkapplicable == true) {
                    if (this.savemeetlink == false) {
                        this.showSnackbar("#b71c1c", "Please Enter Valid Meeting URL......!");
                        this.showSnackbar("#b71c1c", "Please add data !!!");
                        return;
                    }
                }
               
                const data = {
                    courseId: this.course,
                    chapters: this.selected_chapter,
                    quiztype: this.selected_quiztype,
                };
                axios
                    .post("/QuizScheduling/getquestiontable", data)
                    .then((res) => {
                        //  console.log(res.data)
                        if (res.data.flag == "YES") {
                            this.questions = res.data.questions;
                            if(this.questions.length == 0){
                                this.showSnackbar("#b71c1c", "Questions are not added for this subject !!!");
                                return
                            }
                            this.showtable = true;
                        } else {
                            this.showSnackbar("#b71c1c", "Please add data !!!");
                            //this.showSnackbar("error", "Please add data !!!");
                        }
                    })
                    .catch((error) => {})
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            openWindow(w, h) {
                //alert("openWindow")
                var leftOffset = screen.width / 2 - w / 2;
                var topOffset = screen.height / 2 - h / 2;
                window.open("https://us04web.zoom.us/signin", this.target, "left=" + leftOffset + ",top=" + topOffset + ",width=" + w + ",height=" + h + ",resizable,scrollbars=yes");
            },
            openWindowMeet(w, h) {
                //alert("openWindowMeet")
                var leftOffset = screen.width / 2 - w / 2;
                var topOffset = screen.height / 2 - h / 2;
                return window.open("https://meet.google.com/", this.target, "left=" + leftOffset + ",top=" + topOffset + ",width=" + w + ",height=" + h + ",resizable,scrollbars=yes");
            },
            getDivisions(item) {
                //alert("item---"+item.course_id)
                this.course = item.course_id;
                const formData = {
                    course: item.course_id,
                };
                axios
                    .post("/QuizScheduling/getDivisions", formData)
                    .then((res) => {
                        //  console.log(res.data)
                        if (res.data.flag == "YES") {
                            this.dividionlist = res.data.divisions;
                            this.chapters = res.data.chapters;
                            this.quiztype = res.data.quiztype;
                        } else {
                            //   window.console.log(res.data.msg);
                            //  this.showSnackbar("Something went wrong!", "error", 5000);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onLoad() {
                axios
                    .post("/QuizScheduling/scheduleQuiz")
                    .then((res) => {
                        //  console.log(res.data)
                        if (res.data.flag == "YES") {
                            this.course_offering_instructor_details = res.data.course_offering_instructor_details;
                            this.offeredQuizList = res.data.quizSchedulings;
                            this.basepath = res.data.aws_path;
                            //this.dividionlist = res.data.dividionlist;
                            // alert("successful response");
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
        },
        watch: {},
        mounted() {
            this.onLoad();
        },
        computed: {
            edit_date_fun: () => {
                // alert("edit_date_fun")
                return new Date().toISOString().split("T")[0];
            },
            copy_date_fun: () => {
                // alert("edit_date_fun")
                return new Date().toISOString().split("T")[0];
            },
        },
        editorConfig: {
            extraPlugins: "mathjax",
            mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
        },
        updated: function () {
            // console.log("Inside updated");
            this.$nextTick().then(() => {
                if (window.MathJax) {
                    // console.log("rendering mathjax");
                    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                }
            });
        },
    };
</script>
<style scoped>
    sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }

    i {
        font-size: 20px !important;
    }

    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }
    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }

    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }

    i {
        font-size: 26px;
        cursor: pointer;
    }

    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }

    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

    @media only screen and (max-width: 600px) {
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }
    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }
     .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
</style>
